import styled from 'styled-components';

export const SelectWrapper = styled.div`
    margin: 4px;
    display: flex;
    align-items: center;
    position: relative;
    min-width: 180px;
    > div {
        margin-bottom: 0;
    }

    > div:nth-of-type(2) {
        flex: 1;
    }
`;
